import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import firebase from '../../firebase';


export function withAuthRequired(WrappedComponent) {
    return class extends Component {
        state = {
            isLoading: true,
            isAuthenticated: true,
        };

        componentDidMount() {
            firebase.auth().onAuthStateChanged(user => {
                this.setState({ 
                    isAuthenticated: Boolean(user),
                    isLoading: false,
                });
            });
        }

        render() {
            const { isLoading, isAuthenticated } = this.state;

            if (isLoading) return null;

            if (!isAuthenticated) {
                return <Redirect to="/login" />;
            }

            return <WrappedComponent />;
        }
    }
}
